<template>
    <div>
        <nav-breadcrumb :menu="[{label: '发起债转用印申请'}]"/>
        <panel  label="基本信息">
            <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
                <el-row :gutter="10" class="bg-purple xamhtrpg">
                    <el-col :span="24" >
                        <el-form-item label="用印类型：" prop="t__applicationTypeCode" :rules="{required: true, message: '不能为空'}" >
                            <el-select placeholder="请选择类型" v-model.trim="dataForm.t__applicationTypeCode" disabled>
                                <el-option label="债转用印" value="ZZ" ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="用印日期：" prop="t__applicationDate" :rules="{required: true, message: '不能为空'}">
                            <el-date-picker
                                v-model="dataForm.t__applicationDate"
                                value-format="yyyy-MM-dd hh:mm:ss"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="所需盖章：" prop="t__companySeal" :rules="{required: true, message: '不能为空'}">
                            <el-checkbox  v-model="dataForm.t__companySeal" true-label="Y" false-label="N" >公章</el-checkbox>
                            <el-checkbox  v-model="dataForm.t__legalRepSeal" true-label="Y" false-label="N" >法人章</el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="用印描述：" style="width: 60%">
                            <el-input type="textarea" v-model="dataForm.t__remarks" style="margin-bottom:10px;" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </panel>
        <panel >
            <div class="panel-flex-between">
                <div class="Htitle-text">关联信息</div>
                <i class="el-icon-circle-plus" @click="addDetail()" style="transform: scale(2);cursor: pointer;color:#409EFF;"></i>
            </div>

            <panel v-for="(item,idx) in dataForm.detail"
                   :key="idx"
            style="border: solid 1px #ddd;">
                <panel >
                    <div class="panel-flex-between">
                        <div class="Htitle-text">债转信息</div>
                        <i class="el-icon-remove" @click="deleteDetail(idx)" style="transform: scale(2);cursor: pointer;color:#409EFF;"></i>
                    </div>
                    <el-form :model="item" label-width="170px" class="xzformitemmb" ref="dataForm1" >
                        <el-row>
                            <panel border>
                                <el-col :span="12">
                                    <el-form-item label="债转编号  ：" prop="t__transactionNo" :rules="{required: true, message: '不能为空'}">
                                        {{item.t__transactionNo}}&nbsp;&nbsp;&nbsp;<el-button  type="primary" size="mini"  @click="selectFinance(idx)">选择</el-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="债转状态：">
                                        {{(item.t__transactionStatus?(item.t__transactionStatus):'')|Status2CN}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="转让人：">
                                        {{item.pfr__partnerName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="受让人：">
                                        {{item.pto__partnerName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="贷款编号 ：" >
                                        {{item.fi__transactionNo}}&nbsp;&nbsp;&nbsp;
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="贷款期限："  style="width: 100%">
                                        {{item.fi__startDate|moment('YYYY-MM-DD')}}~{{item.fi__endDate|moment('YYYY-MM-DD')}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="客户姓名：">
                                        {{item.ba__customerName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="身份证号：">
                                        {{item.ba__customerIC}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="贷款金额：">
                                        {{item.fi__totalAmount|formatMoney}} 元
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="担保合同编号：">
                                        {{item.fi__warrantNo}}
                                    </el-form-item>
                                </el-col>


                                <el-col :span="12">
                                    <el-form-item label="债转日期：">
                                        {{item.t__transactionDate|moment('YYYY-MM-DD')}}
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="债转金额：">
                                        {{item.t__netEquityValue|formatMoney}} 元
                                    </el-form-item>
                                </el-col>

                            </panel>
                        </el-row>
                    </el-form>
                </panel>
                <panel title="盖章文件">
                    <el-row class="xzpadd10 bg-purple">
                        <data-table
                            :tableData="dataForm.detail[idx].fileData"
                            :columns="filecolumns"
                            :is-pagination-show="false"
                        ></data-table>
                    </el-row>
                    <files-upload :file-list.sync="dataForm.detail[idx].fileList" :max="100" :allow-file-ext="['PDF', 'Word', 'Excel', 'JPG', 'PNG', 'BMP', 'GIF', 'RAR', 'ZIP']" :additional-columns="additionalColumns"></files-upload>
                </panel>
            </panel>

        </panel>
        <div class="tr xzmt">
            <el-button type="primary" @click="onSubmit('dataForm')">确认提交</el-button>
            <el-button @click="$router.back()">取消</el-button>
        </div>
        <el-dialog title="选择"
                   :visible.sync="dialogVisible" @close="dataRelaod()">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </el-dialog>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import Status2CN from "../../filters/Status2CN";
    import moment from 'moment'
    import Panel from "../../components/Panel";
    import {formatMoney} from "../../filters/CommonFilters";
    import {xmlBuildQuery} from "../../filters/CommonActions";
    export default  {
        name: "ContractSealProcess",
        data(){
            return {
                filecolumns:[
                    {
                        label:'文件名称',
                        field:'fileName',
                    },
                    {
                        label: '盖章份数',
                        field: 'copies',
                        component: 'el-input',
                        type: 'number',
                        props: {
                            step: 1
                        },
                    },
                    {
                        label:'操作',
                        opts: [
                            {
                                label: '删除附件',
                                class: 'el-icon-remove',
                                clickHandler: (index, row, data) => {
                                    this.$confirm('确认删除当前文件吗？一旦删除，就无法重新加回来了。').then(()=>{
                                        data.data.splice(index,1)
                                    })

                                }

                            },
                            {
                                label: '下载',
                                class: 'el-icon-download',
                                clickHandler: (index, row, data) => {
                                    //alert(row.fileURL.substr(8,row.fileURL.length-1))
                                    if(row.fileURL.substr(0,6)=='static'){
                                        window.open(row.fileURL)
                                    }else{
                                        window.open(row.fileURL.substr(8,row.fileURL.length-1))
                                    }


                                }

                            }
                        ]

                    }
                ],
                applicationId: this.$route.query['applicationId']||'',
                dataForm: {
                    t__companySeal:'Y',
                    t__legalRepSeal:'N',
                    t__applicationTypeCode:'ZZ',
                    t__applicationDate: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                    detail:[{
                        fileList: [],
                    }]
                },
                bankFormFiles: [],
                dataFormRules: {},
                dialogVisible:false,
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions:[],
                filters: {
                    labelWidth: '150px',
                    form: {
                        t__transactionNo:'',
                        ba__customerName:'',
                        ba__customerContactNo:'',
                        fi__transactionNo:'',
                    },
                    columns: [
                        {
                            label: '债转编号',
                            component: 'el-input',
                            field: 't__transactionNo'
                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'ba__customerName'
                        },
                        {
                            label: '手机号',
                            component: 'el-input',
                            field: 'ba__customerContactNo'
                        },
                        {
                            label: '贷款编号',
                            component: 'el-input',
                            field: 'fi__transactionNo'
                        },


                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                },
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '债转编号',
                        field: 't__transactionNo'
                    },
                    {
                        label: '贷款编号',
                        field: 'fi__transactionNo'
                    },
                    {
                        label: '客户名称',
                        field: 'ba__customerName',

                    },
                    {
                        label: '手机号',
                        field: 'ba__customerContactNo',

                    },
                    {
                        label: '受让人',
                        field: 'pto__partnerName'
                    },
                    {
                        label: '操作',
                        opts:[

                            {
                                class: 'el-icon-check',
                                name: '选择',
                                clickHandler: (index, row)=>{
                                    if(this.selectKeys>-1){
                                        let item = this.dataForm.detail[this.selectKeys]
                                        item.fi__transactionNo = row.fi__transactionNo
                                        item.t__transactionNo = row.t__transactionNo
                                        item.t__transactionStatus = row.t__transactionStatus
                                        item.pfr__partnerName = row.pfr__partnerName
                                        item.pto__partnerName = row.pto__partnerName
                                        item.fi__startDate = row.fi__startDate
                                        item.fi__endDate = row.fi__endDate
                                        item.ba__customerName = row.ba__customerName
                                        item.ba__customerIC = row.ba__customerIC
                                        item.fi__totalAmount = row.fi__totalAmount
                                        item.fi__warrantNo = row.fi__warrantNo


                                        item.t__transactionDate = row.t__transactionDate
                                        item.t__netEquityValue = row.t__netEquityValue
                                        item.de__referenceId = row.t__transactionId
                                        item.de__checked = true
                                        this.dialogVisible = false

                                        const  fileData = { data:[]}

                                        fileData.data.push({
                                            fileName:'债权转让协议.pdf',
                                            fileURL:'report://extended/markup/t/docs/financing/ZRXY.pdf?t.transactionId='+item.de__referenceId ,
                                            copies:2
                                        })
                                        this.dataForm.detail[this.selectKeys].fileData = fileData
                                    }

                                }
                            }
                        ]
                    }
                ],
                additionalColumns: [
                    {
                        label: '盖章份数',
                        field: 'copies',
                        component: 'el-input',
                        type: 'number',
                        props: {
                            step: 1
                        },
                    }
                ],
                selectKeys:-1,
            }
        },
        filters: {

            Status2CN
        },
        computed:{
            filterParams: {
                get: function() {
                    return {
                        pageSize: this.pageSize,
                        pageOffset: (this.page - 1) * this.pageSize,
                        'xlist.search.fi.transactionStatus' : 'Processing,Ready,Settled',
                        'xlist.search.fi.transactionStatus.op' : 'in',
                        'xlist.sort.dataField': 'fi.startDate',
                        'xlist.sort.order': 'desc'
                    }
                },
                set:function (newVal) {

                }
            }
        },
        mounted() {
            if(this.applicationId){
                this.getData2()
            }
        },
        methods: {
            getData2:function(){
                xhr.getViewSealApplication({
                        't.applicationId': this.applicationId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                const dataForm = res.data.data
                                dataForm.detail.forEach((item, idx)=>{
                                    xhr.getEquitySwapTxSelect(
                                        Object.assign({
                                            'xlist.search.t.transactionId' : item.de__referenceId,
                                            'xlist.search.t.transactionId.op' : 'in',
                                        }, {},{}),
                                        res => {
                                            try {
                                                let row = res.data.data[0]
                                                item.fi__transactionNo = row.fi__transactionNo
                                                item.t__transactionNo = row.t__transactionNo
                                                item.t__transactionStatus = row.t__transactionStatus
                                                item.pfr__partnerName = row.pfr__partnerName
                                                item.pto__partnerName = row.pto__partnerName
                                                item.fi__startDate = row.fi__startDate
                                                item.fi__endDate = row.fi__endDate
                                                item.ba__customerName = row.ba__customerName
                                                item.ba__customerIC = row.ba__customerIC
                                                item.fi__totalAmount = row.fi__totalAmount
                                                item.fi__warrantNo = row.fi__warrantNo


                                                item.t__transactionDate = row.t__transactionDate
                                                item.t__netEquityValue = row.t__netEquityValue
                                                item.de__referenceId = row.t__transactionId
                                                item.de__checked = true


                                                this.$set(item, 'fileList', [])
                                                this.$set(item, 'fileData', {data:[]})

                                                item.de__docs.forEach(items=>{
                                                    if(items.fileURL.substr(0,6)=='report'){
                                                        item.fileData.data.push({
                                                            'fileName':items.fileName,
                                                            'copies':items.copies,
                                                            'fileURL':items.fileURL,
                                                        })
                                                    }else{
                                                        item.fileList.push({
                                                            'name':items.fileName,
                                                            'size':items.fileSize,
                                                            'fileId':items.fileURL,
                                                            'copies':items.copies,
                                                        })
                                                    }

                                                })
                                                this.dataForm = dataForm
                                                this.$set(this.dataForm.detail, idx, item)
                                            } catch (e) {

                                            }
                                        })

                                })
                            }
                        }catch (e) {

                        }
                    })
            },
            Status2CN,
            addDetail:function () {
                this.dataForm.detail.push({
                    fileList: []
                })
            },
            deleteDetail:function (index) {
                this.dataForm.detail.splice(index,1)
            },
            selectFinance:function (index) {

                this.selectKeys = index
                this.dialogVisible = true
                this.getData()

            },
            dataRelaod:function () {
                this.selectKeys = -1
            },
            getData: function () {
                xhr.getEquitySwapTxSelect(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res => {
                        try {
                            this.tableData = res.data
                        } catch (e) {

                        }
                    })
            },
            onSubmit: function (formName) {
                let dataForm = this.dataForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        let next = true
                        dataForm.detail.forEach(item=>{
                            if(item.de__referenceId){

                            }else{
                                this.$alert('有债转信息未选择')
                                next =  false
                            }
                            let doc = []
                            if(item.fileList.length==0&&item.fileData.data.length==0){
                                this.$alert('盖章文件未上传全')
                                next =  false
                            }else{

                            }

                            item.fileList.forEach(items=>{
                                doc.push({
                                    'fileName':items.name,
                                    'fileSize':items.size,
                                    'fileURL':items.fileId,
                                    'copies':items.copies,
                                })
                            })
                            item.fileData.data.forEach(items=>{
                                doc.push({
                                    'fileName':items.fileName,
                                    'fileSize':items.fileSize,
                                    'fileURL':items.fileURL,
                                    'copies':items.copies,
                                })
                            })

                            item.de__docs = doc
                        })
                        if(this.dataForm.t__legalRepSeal ==='N'){
                            this.$confirm(`您未勾选“法人章”，请确认不需要盖”法人章”吗?`)
                                .then(() => {
                                    if(next){
                                        dataForm.t__applicationId = ''
                                        dataForm.t__checked = true
                                        dataForm['t.applicationDate.dateformat'] = 'yyyy-MM-dd hh:mm:ss'
                                        xhr.saveSealApplicationForApproval(
                                            dataForm,
                                            res=> {
                                                try{
                                                    if(res.data.status == 'success') {

                                                    }else{

                                                        this.$message.error(res.data.msgs[0].text)
                                                    }
                                                    this.$router.push({
                                                        name: 'ContractSealProcessListView'
                                                    })
                                                }catch (e) {

                                                    this.$message.error(error.msgs[0].text)

                                                }
                                            }
                                        )
                                    }
                                })
                                .catch(() => {

                                })
                        }else {
                            if(next){
                                dataForm.t__applicationId = ''
                                dataForm.t__checked = true
                                dataForm['t.applicationDate.dateformat'] = 'yyyy-MM-dd hh:mm:ss'
                                xhr.saveSealApplicationForApproval(
                                    dataForm,
                                    res=> {
                                        try{
                                            if(res.data.status == 'success') {

                                            }else{

                                                this.$message.error(res.data.msgs[0].text)
                                            }
                                            this.$router.push({
                                                name: 'ContractSealProcessListView'
                                            })
                                        }catch (e) {

                                            this.$message.error(error.msgs[0].text)

                                        }
                                    }
                                )
                            }
                        }



                    }
                })
            }
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ContractSealProcessZZ.vue